// tslint:disable
export enum TCSTaskDisposition {
    /**
     * @description None
     */
    None = 0,
    /**
     * @description Task Disposition 1 - Phone no longer in service
     */
    PhoneNoLongerInService = 1,
    /**
     * @description Task Disposition 2 - Unable to contact/Other/First attempt
     */
    UnableToContactOtherFirstAttempt = 2,
    /**
     * @description Task Disposition 3 - Unable to contact/Other/Second attempt
     */
    UnableToContactOtherSecondAttempt = 3,
    /**
     * @description Task Disposition 4 - Insurance change
     */
    InsuranceChange = 4,
    /**
     * @description Task Disposition 5 - Patient contacted/Insurance not changing
     */
    PatientContactedInsuranceNotChanging = 5,
    /**
     * @description Task Disposition 6 - Transition inform letter/No inbound call
     */
    TransitionInformLetterNoInboundCall = 6,
    /**
     * @description Task Disposition 7 - Unable to contact letter/No inbound call
     */
    UnableToContactLetterNoInboundCall = 7,
    /**
     * @description Task Disposition 8 - Maximizer-impacted patient/Self-attest
     */
    MaximizerImpactedPatientSelfAttest = 8,
    /**
     * @description Task Disposition 9 - CAPm unenroll, no out-of-pocket
     */
    CapMUnenrollNoOutOfPocket = 9,
}
(TCSTaskDisposition as any)['NONE'] = 0;
(TCSTaskDisposition as any)['PHONENOLONGERINSERVICE'] = 1;
(TCSTaskDisposition as any)['UNABLETOCONTACTOTHERFIRSTATTEMPT'] = 2;
(TCSTaskDisposition as any)['UNABLETOCONTACTOTHERSECONDATTEMPT'] = 3;
(TCSTaskDisposition as any)['INSURANCECHANGE'] = 4;
(TCSTaskDisposition as any)['PATIENTCONTACTEDINSURANCENOTCHANGING'] = 5;
(TCSTaskDisposition as any)['TRANSITIONINFORMLETTERNOINBOUNDCALL'] = 6;
(TCSTaskDisposition as any)['UNABLETOCONTACTLETTERNOINBOUNDCALL'] = 7;
(TCSTaskDisposition as any)['MAXIMIZERIMPACTEDPATIENTSELFATTEST'] = 8;
(TCSTaskDisposition as any)['CAPMUNENROLLNOOUTOFPOCKET'] = 9;
